export const SEGMENT_TITLE = {

    FINTECH: 'fintech-loan-protection-insurance',
    ELECTRONICS: 'electronic-device-insurance',
    TRAVEL: 'group-travel-insurance',
    HEALTH: 'group-health-insurance',
    GIG: 'gig-worker-health-insurance',

}

export const SEGMENT_TITLE_CONFIG = {

    [SEGMENT_TITLE.FINTECH]: {

        title: 'Fintech'
    },

    [SEGMENT_TITLE.ELECTRONICS]: {

        title: 'Electronics'

    },

    [SEGMENT_TITLE.TRAVEL]: {

        title: 'Travel'

    },

    [SEGMENT_TITLE.HEALTH]: {

        title: 'Health'

    },

    [SEGMENT_TITLE.GIG]: {

        title: 'Gig Workers'

    }
}

export const TAP_BTN_AFB_LEAD_FORM_SUBMIT = 'tap_btn_afb_lead_form_submit'

export const VIEW_AFB_PAGE = 'view_afb_page'
